import ts from 'typescript';
export function isUndefined(identifier) {
    return identifier.originalKeywordKind === ts.SyntaxKind.UndefinedKeyword;
}

//# sourceMappingURL=identifier.js.map
